import { addMonths, format, isBefore, parseISO, startOfMonth } from "date-fns";

/**
 * Transforms a date range object into an array of month strings in YYYY-MM format
 * @param {object} range - Object with 'from' and 'to' date strings in YYYY-MM-DD format
 * @returns {string[]} Array of months in 'YYYY-MM' format
 */
export default (range: { from: string; to: string }): string[] => {
  if (!range || typeof range !== "object") {
    return [];
  }

  const { from, to } = range;

  const startDate = parseISO(from);
  const endDate = parseISO(to);

  const months: string[] = [];

  let currentMonth = startOfMonth(startDate);
  const endMonth = startOfMonth(endDate);

  while (
    isBefore(currentMonth, endMonth) ||
    currentMonth.getTime() === endMonth.getTime()
  ) {
    months.push(format(currentMonth, "yyyy-MM"));
    currentMonth = addMonths(currentMonth, 1);
  }

  return months;
};
